<div class="ecpl-tree-root angular-tree-component tree-grid-custom">
  <div class="tree-nodes-container">
    <ng-container *ngFor="let n of wrapperNodes; let i = index">
      <div
        *ngIf="isShown(n)"
        class="tree-node-item"
        [class.has-children]="n.nodes && n.nodes.length > 0"
        [class.is-expanded]="n.isExpanded"
      >
        <div class="tree-node-box">
          <div class="tree-node-main">
            <ng-container
              *ngTemplateOutlet="
                nodeTemplate;
                context: { $implicit: n, node: n, index: i }
              "
            ></ng-container>
          </div>
          <button
            type="button"
            [attr.aria-expanded]="n.isExpanded"
            [attr.aria-label]="n.data.title || n.data.name || n.id"
            class="tree-node-expander"
            [class.leaf-node]="!n.nodes || n.nodes.length === 0"
            (click)="n.nodes && n.nodes.length > 0 && n.toggleExpand()"
          >
            <i
              *ngIf="n.nodes && n.nodes.length > 0"
              [class]="
                n.isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
              "
            ></i>
          </button>
        </div>
        <div
          class="tree-children-dropdown"
          *ngIf="n.isExpanded && n.nodes && n.nodes.length > 0"
        >
          <ng-container *ngFor="let child of n.nodes; let j = index">
            <div *ngIf="isShown(child)" class="tree-child-item">
              <ng-container
                *ngTemplateOutlet="
                  nodeTemplate;
                  context: { $implicit: child, node: child, index: j }
                "
              ></ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
